<template>
    <div class="l-section__content">
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: 'block-content',
};
</script>
